import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import service from "core/presentation/services/FetchInterceptor";
import { RootState } from "core/presentation/store";

type AuditReportParams = {
  page?: number;
  limit?: number;
  search?: string;
  entity?: string;
};

type AuditReportDetailParams = {
  id: number;
};

export const getAuditReportListThunk = createAsyncThunk<any, AuditReportParams, { state: RootState }>("audit/getAuditReportList", async ({ page = 1, limit = 10, search = "", entity = "" }, { rejectWithValue }) => {
  try {
    const response = await service.get("/audit/report", {
      params: { page, limit, search, entity },
    });
    return response;
  } catch (error: any) {
    return rejectWithValue(error?.response?.data || "Failed to fetch audit report");
  }
});

export const getAuditReportDetailThunk = createAsyncThunk<any, AuditReportDetailParams, { state: RootState }>("audit/getAuditReportDetail", async ({ id }, { rejectWithValue }) => {
  try {
    return await service.get(`/audit/report/${id}`);
  } catch (error: any) {
    return rejectWithValue(error?.response?.data || "Failed to fetch audit detail");
  }
});

const initialState = {
  auditLogs: [],
  auditLogCount: 0,
  auditDetail: null,
  isLoading: false,
  error: null as any,
};

export const auditSlice = createSlice({
  name: "audit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAuditReportListThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAuditReportListThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.auditLogs = action.payload?.data?.logData || [];
        state.auditLogCount = action.payload?.data?.count || 0;
      })
      .addCase(getAuditReportListThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getAuditReportDetailThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAuditReportDetailThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.auditDetail = action.payload?.data || null;
      })
      .addCase(getAuditReportDetailThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const auditReducer = auditSlice.reducer;
export const auditThunks = {
  getAuditReportListThunk,
  getAuditReportDetailThunk,
};